import { useTranslation } from 'react-i18next';
import { StyledModal, StyledModalQuestion, SaveDiscardButtonsGroup } from 'components/styledComponents/modal/Modal.styled';
import { IconSvg } from 'shared/icon';
import { StyledIconDefault } from 'shared/icon/Icon.styled';
import { StyledButtonBlue, StyledButtonBlueUnbordered } from 'components/styledComponents/button/Button.styled';
import { ReactNode } from 'react';
import { Info } from 'shared/ui';

interface ConfirmModalProps {
  visible: boolean;
  propsWidth?: string;
  text: ReactNode;
  info?: string;
  changeModalState?: (value: boolean) => void;
  handleConfirm?: () => void;
  handleCancel?: () => void;
  okText?: string;
  closeText?: string;
  hideClose?: boolean;
  title?: string;
}

const ConfirmModal = ({
  visible, changeModalState, text, info, handleConfirm, handleCancel, okText = 'yes', closeText = 'cancel', propsWidth = '26.3rem', hideClose = false, title,
}: ConfirmModalProps) => {
  const { t } = useTranslation();

  // at first close modal, than call handle Confirm , it's important in translation
  const onOk = () => {
    changeModalState?.(false);
    handleConfirm?.();
  };

  const onCancel = () => {
    changeModalState?.(false);
    handleCancel?.();
  };

  return (
    <StyledModal
      getContainer=".ant-layout-content"
      open={visible}
      onOk={onOk}
      onCancel={onCancel}
      width={propsWidth}
      closable
      centered
      title={title}
      $mdPaddings
      closeIcon={(
        <StyledIconDefault>
          <IconSvg icon="CloseModalIcon" width="1.14rem" height="1.14rem" />
        </StyledIconDefault>
      )}
      zIndex={10000}
      className="confirm-modal"
      footer={(
        <SaveDiscardButtonsGroup $isCenter={!hideClose}>
          {!hideClose && (
            <StyledButtonBlueUnbordered onClick={onCancel} size="large">
              {t(closeText)}
            </StyledButtonBlueUnbordered>
          )}
          <StyledButtonBlue htmlType="submit" onClick={onOk} size="large">
            {t(okText)}
          </StyledButtonBlue>
        </SaveDiscardButtonsGroup>
      )}
    >
      {info && <Info content={info} />}
      <StyledModalQuestion>{text}</StyledModalQuestion>
    </StyledModal>
  );
};

export default ConfirmModal;
